import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { StorySection } from "./components/sections/StorySection";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { About } from "./components/sections/About";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
export function App() {
  return <div className="min-h-screen w-full bg-cream-100 font-sans text-ink" data-id="element-0" data-mp="23ti8y6semyl9">
      <MetaPixel data-id="element-1" data-mp="3ijfu9xduvsdk" />
      <Hero data-id="element-2" data-mp="3ihv0wb3a2fha" />
      <main data-id="element-3" data-mp="3mlj9mx3nbh44">
        <StorySection data-id="element-4" data-mp="3mlax56bfqdtg" />
        <BeforeAfter data-id="element-5" data-mp="3mkhlbqxmcy4g" />
        <PainPoints data-id="element-6" data-mp="3mjzu58ptda3e" />
        <Volumes data-id="element-7" data-mp="3mjgczu7zmpqf" />
        <Tools data-id="element-8" data-mp="3rc9hqi3ghy2i" />
        <Bonuses data-id="element-9" data-mp="3rbrbqtqzs5he" />
        <Offer data-id="element-10" data-mp="3rdar8i4tqci4" />
        <Guarantee data-id="element-11" data-mp="3rcsw5otwe4bs" />
        <Testimonials data-id="element-12" data-mp="3reccfffk0fdk" />
        <About data-id="element-13" data-mp="5ot150vj28n" />
        <Faq data-id="element-14" data-mp="6htjo98ovic" />
        <FinalCta data-id="element-15" data-mp="4wx1t3d72hu" />
      </main>
      <FloatingCta anchorId="hero-cta" data-id="element-16" data-mp="56qjqnmbrsa" />
      <PurchasePopup data-id="element-17" data-mp="2zllf11m4wkmq" />
    </div>;
}